import ApiService, { IRequestParameters } from '@/plugins/api-plugin/services/api.service'
import LayoutSummaryDao from '@/interfaces/admin/LayoutSummary.dao'
import LayoutLookupsDao from '@/interfaces/admin/LayoutLookups.dao'
import LayoutDetailDao from '@/interfaces/admin/LayoutDetail.dao'
import WriteLayoutDao from '@/interfaces/admin/WriteLayout.dao'
import { PageNumberPagination } from '@/interfaces/common/PageNumberPagination'

export default class LayoutsService extends ApiService {
    async getLayouts(params?: IRequestParameters): Promise<[LayoutSummaryDao[], PageNumberPagination] | null> {
        return this.request<undefined, [LayoutSummaryDao[], PageNumberPagination] | null>(
            'GET',
            '/layouts',
            params,
            undefined,
            undefined,
            'getLayouts',
        ).catch(() => null)
    }

    async getLayoutLookups(): Promise<LayoutLookupsDao | null> {
        return this.request<undefined, LayoutLookupsDao>(
            'GET',
            '/layouts/lookups',
            undefined,
            undefined,
            undefined,
            'getLayoutLookups',
        ).catch(() => null)
    }

    async getLayout(id: number): Promise<LayoutDetailDao | null> {
        return this.request<undefined, LayoutDetailDao>(
            'GET',
            `/layouts/${id}`,
            undefined,
            undefined,
            undefined,
            'getLayout',
        ).catch(() => null)
    }

    async createLayout(dto: WriteLayoutDao): Promise<LayoutDetailDao | null> {
        return this.request<WriteLayoutDao, LayoutDetailDao>(
            'POST',
            '/layouts',
            undefined,
            dto,
            undefined,
            'createLayout',
        ).catch(() => null)
    }

    async updateLayout(id: number, dto: WriteLayoutDao): Promise<LayoutDetailDao | null> {
        return this.request<WriteLayoutDao, LayoutDetailDao>(
            'PUT',
            `/layouts/${id}`,
            undefined,
            dto,
            undefined,
            'updateLayout',
        ).catch(() => null)
    }
}
